import React from 'react';
import { Container, Row } from 'react-bootstrap';
//import './PanelConext.css';

function PanelContext(props) {
  
    const { title } = props;

    return (
        <Container fluid className="full-screen-container bg-dark text-light border rounded p-4 shadow">
            <Row>
                <h2 className="text-start">{props.title}</h2>
            </Row>
            <hr />   
            {props.children}         
        </Container>
    )
}

export default PanelContext;